// store/modules/DataMove.js
export const state = {
    dataMove: {}
  };
  
  export const mutations = {
    SET_DATA(state, detail) {
      state.dataMove = detail;
    }
  };
  
  export const actions = {
    setData({ commit }, detail) {
      commit('SET_DATA', detail);
    }
  };
  
  export const getters = {
    getDataMove: state => state.dataMove
  };
  
  